var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { noCase } from "text-no-case";
import { upperCaseFirst } from "text-upper-case-first";
export function sentenceCaseTransform(input, index) {
  var result = input.toLowerCase();
  if (index === 0) return upperCaseFirst(result);
  return result;
}
export function sentenceCase(input, options) {
  if (options === void 0) {
    options = {};
  }

  return noCase(input, __assign({
    delimiter: " ",
    transform: sentenceCaseTransform
  }, options));
}